import api from '../config/api';

export const recruitmentCompanyService = {
  /**
   * Get recruitment company profile
   * @returns {Promise}
   */
  getProfile: async () => {
    const response = await api.get('/recruitment-company/profile');
    return response.data;
  },

  /**
   * Update recruitment company profile
   * @param {Object|FormData} data
   * @returns {Promise}
   */
  updateProfile: async (data) => {
    const config = {};
    if (data instanceof FormData) {
      config.headers = {
        'Content-Type': 'multipart/form-data',
      };
    }
    const response = await api.post('/recruitment-company/profile', data, config);
    return response.data;
  },

  /**
   * Get recruitment company plans
   * @returns {Promise}
   */
  getPlans: async () => {
    const response = await api.get('/recruitment-company/plans');
    return response.data;
  },

  /**
   * Get plan by ID
   * @param {number} id
   * @returns {Promise}
   */
  getPlan: async (id) => {
    const response = await api.get(`/recruitment-company/plans/${id}`);
    return response.data;
  },

  /**
   * Subscribe to a plan
   * @param {number} planId
   * @returns {Promise}
   */
  subscribe: async (planId) => {
    const response = await api.post('/recruitment-company/subscriptions', { plan_id: planId });
    return response.data;
  },

  /**
   * Get subscriptions
   * @param {Object} filters
   * @returns {Promise}
   */
  getSubscriptions: async (filters = {}) => {
    const response = await api.get('/recruitment-company/subscriptions', { params: filters });
    return response.data;
  },

  /**
   * Cancel subscription
   * @param {number} subscriptionId
   * @returns {Promise}
   */
  cancelSubscription: async (subscriptionId) => {
    const response = await api.post(`/recruitment-company/subscriptions/${subscriptionId}/cancel`);
        return response.data;
    },

    /**
     * Get employee profile by ID (for recruitment companies viewing applicants)
     * @param {number} employeeId
     * @returns {Promise}
     */
    getEmployeeProfile: async (employeeId) => {
        const response = await api.get(`/recruitment-company/employees/${employeeId}`);
        return response.data;
    },

    /**
     * Get recruitment company users
     * @returns {Promise}
     */
    getUsers: async () => {
        const response = await api.get('/recruitment-company/users');
        return response.data;
    },

    /**
     * Add user to recruitment company
     * @param {Object} data
     * @returns {Promise}
     */
    addUser: async (data) => {
        const response = await api.post('/recruitment-company/users', data);
        return response.data;
    },

    /**
     * Update recruitment company user
     * @param {number} userId
     * @param {Object} data
     * @returns {Promise}
     */
    updateUser: async (userId, data) => {
        const response = await api.put(`/recruitment-company/users/${userId}`, data);
        return response.data;
    },

    /**
     * Remove user from recruitment company
     * @param {number} userId
     * @returns {Promise}
     */
    removeUser: async (userId) => {
        const response = await api.delete(`/recruitment-company/users/${userId}`);
        return response.data;
    },
};

